import { OuraSymbolIcon } from '@jouzen/ecom-components/icons/OuraSymbolIcon';
import { BREAKPOINTS } from '@jouzen/ecom-components/v3/consts/breakpoints';

import { EventType } from '@/analytics/types';
import LandingPageHero from '@/app/components/LandingPage/LandingPageHero';

const PartnershipsHero = () => {
  const handleActionClicked = () => {
    const pathname = new URL('https://partners.ouraring.com/');

    void window.ouraAnalytics.track(EventType.LinkClicked, {
      cta: 'request_a_demo',
      location: 'partnerships hero',
      path: pathname,
    });

    window.open(pathname, '_blank');
  };

  return (
    <section data-cy="partnerships-hero">
      <LandingPageHero
        backgroundImage={{
          localizedSrcSet: [
            {
              src: 'partnership_hero_oreo_mobile',
              media: `(max-width: ${BREAKPOINTS.large}px)`,
            },
            {
              media: `(min-width: ${BREAKPOINTS.large}px)`,
              src: 'partnership_hero_oreo_desktop',
            },
          ],
          localizedAlt: 'partnerships_hero_image_alt',
        }}
        backgroundProps={{
          color: 'slate-600',
          gradients: [],
        }}
        iconTagProps={{
          iconTagText: 'powered_by_oura_camel',
          icon: <OuraSymbolIcon />,
        }}
        title="partnerships_hero_title"
        copy="partnerships_hero_copy"
        copyProps={{
          className: 'text-sandstone-200',
        }}
        textColor="text-sandstone-200"
        cta={{
          onClick: handleActionClicked,
          className: 'bg-sandstone-200 text-sandstone-500 font-bold',
          label: 'partnerships_hero_action',
        }}
      />
    </section>
  );
};

export default PartnershipsHero;
